import styled, { css } from 'styled-components';

import { AlertProps } from './types';

export const AlertAbsolute = styled.div`
	${({ theme }) => css`
		position: absolute;
		top: 0;
		width: 100%;
		z-index: 99;

		@media ${theme.screens.screenGTS} {
			width: auto;
			top: 96px;
			left: 20%;
		}
	`};
`;

export const AlertLargePrepend = styled.div<Partial<AlertProps>>`
	${({ theme, type }) => css`
		display: grid;
		place-content: center;

		${type === 'success' && `background-color: ${theme.colors.success[100]};`}
		${type === 'warning' && `background-color: ${theme.colors.warning[100]};`}
		${type === 'error' && `background-color: ${theme.colors.error[100]};`}

		${type === 'success' && `border-right: solid 1px ${theme.colors.success[300]};`}
		${type === 'warning' && `border-right: solid 1px ${theme.colors.warning[300]};`}
		${type === 'error' && `border-right: solid 1px ${theme.colors.error[300]};`}

		border-radius: ${theme.radii.default} 0 0 ${theme.radii.default};
		min-width: 77px;
	`};
`;

export const AlertLargeMessage = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 16px;
`;

export const AlertLargeContainer = styled.div<Partial<AlertProps>>`
	${({ theme, type }) => {
		const color = theme.colors[type as keyof typeof theme.colors];

		return css`
			display: flex;
			flex-direction: row;
			border-radius: ${theme.radii.default};
			background-color: ${theme.colors.neutral[100]};
			border: solid 1px ${color[300 as keyof typeof color]};
			min-width: 669px;
			min-height: 105px;
		`;
	}};
`;

export const AlertContainer = styled.div<Partial<AlertProps>>`
	${({ theme, type }) => {
		const color = theme.colors[type as keyof typeof theme.colors];
		
		return css`
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			border-radius: ${theme.radii.default};
			background-color: ${theme.colors.neutral[100]};
			padding: 18px 16px;
			border: solid 1px ${color[300 as keyof typeof color]};
		`;
	}};
`;

export const AlertAppend = styled.div`
	${({ theme }) => css`
		display: grid;
		place-content: center;
		background-color: ${theme.colors.neutral[100]};
	`};
`;

export const AlertMessage = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;
